"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceRoundsFeedStarknetContractAdapter = void 0;
class PriceRoundsFeedStarknetContractAdapter {
    contract;
    constructor(contract) {
        this.contract = contract;
    }
    async readLatestRoundData() {
        return (await this.contract.call("latest_round_data"));
    }
}
exports.PriceRoundsFeedStarknetContractAdapter = PriceRoundsFeedStarknetContractAdapter;
//# sourceMappingURL=PriceRoundsFeedStarknetContractAdapter.js.map